import React, { useState, useEffect } from "react";
import axiosInstance from "../../Axios/axiosInstance";
import { useParams } from "react-router-dom";
import { TextField, Button, Grid, Typography, Snackbar } from "@mui/material";
import EditIcon from "@mui/icons-material/Edit";

const UpdateLead = () => {
  const { leadId } = useParams();
  console.log(leadId);
  const [leadData, setLeadData] = useState({
    leadname: "",
    contactno: "",
    leademail: "",
    leadlocation: "",
    leadsource: "",
    leadcomments: "",
    leadstate: "",
    status: "active",
  });

  const [submitMessage, setSubmitMessage] = useState("");
  const [openSnackbar, setOpenSnackbar] = useState(false);
  // const [editMode, setEditMode] = useState(false);

  useEffect(() => {
    const fetchLeadData = async () => {
      try {
        const response = await axiosInstance.get(`/api/getLeads/${leadId}`);
        console.log(response);
        if (response && response.data) {
          setLeadData(response.data);
        } else {
          // Handle error for failed request
        }
      } catch (error) {
        // Handle network errors
      }
    };

    fetchLeadData();
  }, [leadId]);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setLeadData({ ...leadData, [name]: value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      const response = await axiosInstance.put(
        `/api/updateLead/${leadId}`,
        leadData
      );

      if (response.status === 200) {
        setSubmitMessage("Lead data updated successfully!");
        setOpenSnackbar(true);

        setTimeout(() => {
          setOpenSnackbar(false);
          setSubmitMessage("");
        }, 3000);

        // setEditMode(false);
      } else {
        // Handle error for failed request
      }
    } catch (error) {
      // Handle network errors
    }
  };

  // const handleEditClick = () => {
  //   setEditMode(true);
  // };

  return (
    <>
      <form onSubmit={handleSubmit}>
        <Grid
          container
          spacing={3}
        >
          <Grid
            item
            xs={12}
          >
            <Grid
              container
              alignItems="center"
            >
              <Grid
                item
                xs={6}
              >
                <Typography variant="h5">Update Leads Details</Typography>
              </Grid>
              <Grid
                item
                xs={6}
                style={{ justifyContent: "end" }}
              >
                {/* <EditIcon
                  onClick={handleEditClick}
                  style={{ cursor: "pointer" }}
                /> */}
              </Grid>
            </Grid>
          </Grid>

          <Grid
            item
            xs={12}
            className="text-center"
            lg={6}
            md={6}
            sm={12}
          >
            <Grid
              container
              alignItems="center"
            >
              <Grid
                item
                xs={6}
                style={{ textAlign: "left" }}
              >
                <Typography variant="subtitle1">Lead Name</Typography>
              </Grid>
              <Grid
                item
                xs={6}
              >
                <TextField
                  fullWidth
                  name="leadname"
                  value={leadData.leadname}
                  onChange={handleInputChange}
                  size="small"
                  required
                  // disabled={!editMode}
                />
              </Grid>
            </Grid>
          </Grid>

          <Grid
            item
            xs={12}
            className="text-center"
            lg={6}
            md={6}
            sm={12}
          >
            <Grid
              container
              alignItems="center"
            >
              <Grid
                item
                xs={6}
                style={{ textAlign: "left" }}
              >
                <Typography variant="subtitle1">Contact Number</Typography>
              </Grid>
              <Grid
                item
                xs={6}
              >
                <TextField
                  fullWidth
                  name="contactno"
                  value={leadData.contactno}
                  onChange={handleInputChange}
                  size="small"
                  required
                  // disabled={!editMode}
                />
              </Grid>
            </Grid>
          </Grid>

          <Grid
            item
            xs={12}
            className="text-center"
            lg={6}
            md={6}
            sm={12}
          >
            <Grid
              container
              alignItems="center"
            >
              <Grid
                item
                xs={6}
                style={{ textAlign: "left" }}
              >
                <Typography variant="subtitle1">Lead Email</Typography>
              </Grid>
              <Grid
                item
                xs={6}
              >
                <TextField
                  fullWidth
                  name="leademail"
                  value={leadData.leademail}
                  onChange={handleInputChange}
                  size="small"
                  required
                  // disabled={!editMode}
                />
              </Grid>
            </Grid>
          </Grid>

          <Grid
            item
            xs={12}
            className="text-center"
            lg={6}
            md={6}
            sm={12}
          >
            <Grid
              container
              alignItems="center"
            >
              <Grid
                item
                xs={6}
                style={{ textAlign: "left" }}
              >
                <Typography variant="subtitle1">Lead Location</Typography>
              </Grid>
              <Grid
                item
                xs={6}
              >
                <TextField
                  fullWidth
                  name="leadlocation"
                  value={leadData.leadlocation}
                  onChange={handleInputChange}
                  size="small"
                  // disabled={!editMode}
                />
              </Grid>
            </Grid>
          </Grid>

          <Grid
            item
            xs={12}
            className="text-center"
            lg={6}
            md={6}
            sm={12}
          >
            <Grid
              container
              alignItems="center"
            >
              <Grid
                item
                xs={6}
                style={{ textAlign: "left" }}
              >
                <Typography variant="subtitle1">Lead Source</Typography>
              </Grid>
              <Grid
                item
                xs={6}
              >
                <TextField
                  fullWidth
                  name="leadsource"
                  value={leadData.leadsource}
                  onChange={handleInputChange}
                  size="small"
                  // disabled={!editMode}
                />
              </Grid>
            </Grid>
          </Grid>

          <Grid
            item
            xs={12}
            className="text-center"
            lg={6}
            md={6}
            sm={12}
          >
            <Grid
              container
              alignItems="center"
            >
              <Grid
                item
                xs={6}
                style={{ textAlign: "left" }}
              >
                <Typography variant="subtitle1">Lead Comments</Typography>
              </Grid>
              <Grid
                item
                xs={6}
              >
                <TextField
                  fullWidth
                  name="leadcomments"
                  value={leadData.leadcomments}
                  onChange={handleInputChange}
                  size="small"
                  multiline
                  rows={1}
                  // disabled={!editMode}
                />
              </Grid>
            </Grid>
          </Grid>

          <Grid
            item
            xs={12}
            className="text-center"
            lg={6}
            md={6}
            sm={12}
          >
            <Grid
              container
              alignItems="center"
            >
              <Grid
                item
                xs={6}
                style={{ textAlign: "left" }}
              >
                <Typography variant="subtitle1">Lead State</Typography>
              </Grid>
              <Grid
                item
                xs={6}
              >
                <TextField
                  fullWidth
                  name="leadstate"
                  value={leadData.leadstate}
                  onChange={handleInputChange}
                  size="small"
                  // disabled={!editMode}
                />
              </Grid>
            </Grid>
          </Grid>

          {/* You can add more fields in a similar fashion */}

          <Grid
            item
            xs={12}
            className=" mt-5"
          >
            <Button
              variant="contained"
              color="primary"
              type="submit"
              // disabled={!editMode}
            >
              Save
            </Button>
          </Grid>
        </Grid>
      </form>

      <Snackbar
        anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
        open={openSnackbar}
        autoHideDuration={3000}
        message={submitMessage}
      />
    </>
  );
};

export default UpdateLead;
